export default __webpack_public_path__ + "static/media/gallery-wip-emitter_05.9e213b9e.jpg";